/**
 * This file is auto-generated by protobufgen
 * Don't change manually
 */

import { Result as PageResult, ModuleInteraction as PageModuleInteraction } from "../page/common";
import { ExtraInfo as PoolExtraInfo } from "../pool/app";
import webapi from "../webapi";

export enum TModuleType {
	TCollections = "TCollections",
	TMostPopular = "TMostPopular",
	THotCategories = "THotCategories",
	TBanner = "TBanner",
	TFlash = "TFlash",
	TCategory = "TCategory",
	TSwiper = "TSwiper",
	TQuickNav = "TQuickNav",
	THotKeywords = "THotKeywords",
	THotList = "THotList",
	TProductRecommend = "TProductRecommend",
	TCategoryExtension = "TCategoryExtension",
	TTopBanner = "TTopBanner",
	TMagicBannerType = "TMagicBannerType",
	TMultiProductModuleType = "TMultiProductModuleType",
	TPageTitleLineType = "TPageTitleLineType",
	TNavIcons = "TNavIcons",
	TRichText = "TRichText",
	TCountdownBanner = "TCountdownBanner",
	TMagicVoucher = "TMagicVoucher",
	TDiscount = "TDiscount",
	TMultiFlash = "TMultiFlash",
	TSideBanner = "TSideBanner",
	TMultiHeroDeal = "TMultiHeroDeal",
	TLogo = "TLogo",
	THomeBanner = "THomeBanner",
	TNavIconGroups = "TNavIconGroups",
	TMultiCollection = "TMultiCollection",
	TMultiRecPurTab = "TMultiRecPurTab",
	TBottomIcons = "TBottomIcons",
	TShakeIcon = "TShakeIcon",
	TTimelineBanner = "TTimelineBanner",
	TMultiCollectionTwo = "TMultiCollectionTwo",
	TNoLoginBanner = "TNoLoginBanner",
	TFlashArea = "TFlashArea",
	TMillion = "TMillion",
	TEvent = "TEvent",
	TMagicBannerTwo = "TMagicBannerTwo",
	TCoupon = "TCoupon",
	TStickBotomTab = "TStickBotomTab",
	TAll = "TAll",
	TNewMultiBanner = "TNewMultiBanner",
	TNewMultiProduct = "TNewMultiProduct",
	TNewMagicBanner = "TNewMagicBanner",
	TNewVoucher = "TNewVoucher",
	TNewCoupon = "TNewCoupon",
	TNewCountdown = "TNewCountdown",
	TNewFlashProduct = "TNewFlashProduct",
	TNewEvent = "TNewEvent",
}

export const TModuleTypeMap = {
  [TModuleType.TBanner]: "单图 banner",
  [TModuleType.TFlash]: "首页闪购",
  [TModuleType.TCategory]: "一级类目",
  [TModuleType.TSwiper]: "幻灯",
  [TModuleType.TQuickNav]: "快速导航",
  [TModuleType.THotKeywords]: "搜索热词",
  [TModuleType.THotList]: "幻灯下热推",
  [TModuleType.TProductRecommend]: "商品推荐",
  [TModuleType.TCategoryExtension]: "类目扩展类型",
  [TModuleType.TTopBanner]: "顶部 banner",
  [TModuleType.TMagicBannerType]: "magic banner",
  [TModuleType.TMultiProductModuleType]: "商品模块列表",
  [TModuleType.TPageTitleLineType]: "页面标题栏",
  [TModuleType.TNavIcons]: "页面导航icon   TIconGroupModule",
  [TModuleType.TRichText]: "富文本",
  [TModuleType.TCountdownBanner]: "倒计时banner",
  [TModuleType.TMagicVoucher]: "magic voucher",
  [TModuleType.TDiscount]: "活动",
  [TModuleType.TMultiFlash]: "multi闪购商品模块",
  [TModuleType.TSideBanner]: "页面左右两边banner",
  [TModuleType.TMultiHeroDeal]: "hero deal",
  [TModuleType.TLogo]: "首页logo",
  [TModuleType.THomeBanner]: "首页 banner",
  [TModuleType.TNavIconGroups]: "首页导航icon组(金刚区)",
  [TModuleType.TMultiCollection]: "首页collection",
  [TModuleType.TMultiRecPurTab]: "首页recent purchase",
  [TModuleType.TBottomIcons]: "首页底部icon",
  [TModuleType.TShakeIcon]: "首页摇一摇",
  [TModuleType.TTimelineBanner]: "时间线banner",
  [TModuleType.TMultiCollectionTwo]: "collection2",
  [TModuleType.TNoLoginBanner]: "未登录用户的banner",
  [TModuleType.TFlashArea]: "闪购区域，不包含数据（占位用）",
  [TModuleType.TMillion]: "百万补贴区域,暂时不包含数据（占位用）",
  [TModuleType.TEvent]: "活动类事件模块",
  [TModuleType.TMagicBannerTwo]: "magic banner two 多个banner共用同一组热区",
  [TModuleType.TCoupon]: "coupon code",
  [TModuleType.TStickBotomTab]: "吸底tab",
  [TModuleType.TAll]: "全部",
  [TModuleType.TNewMultiBanner]: "多图banner",
}

export enum TPlaygroundType {
	TPlaygroundAll = "TPlaygroundAll",
	TPlaygroundPCHome = "TPlaygroundPCHome",
	TPlaygroundTights = "TPlaygroundTights",
	TPlaygroundSeller = "TPlaygroundSeller",
	TPlaygroundAppHome = "TPlaygroundAppHome",
	TPlaygroundMailTpl = "TPlaygroundMailTpl",
}


export enum GroupType {
	CommonTightsGroup = "CommonTightsGroup",
	MailTplTightsGroup = "MailTplTightsGroup",
	HomePageGroup = "HomePageGroup",
}


export enum TPlatform {
	Pc = "Pc",
	Mobile = "Mobile",
}


export enum Shape {
	Square = "Square",
	RectangleA = "RectangleA",
	RectangleB = "RectangleB",
}

export const ShapeMap = {
  [Shape.RectangleA]: "横放",
  [Shape.RectangleB]: "竖放",
}

export enum AreaColor {
	TextColor = "TextColor",
	TextFocusColor = "TextFocusColor",
	TagFocusColor = "TagFocusColor",
}

export const AreaColorMap = {
  [AreaColor.TextColor]: "字体未选中颜色",
  [AreaColor.TextFocusColor]: "字体选中颜色",
}

export enum ActType {
	NotActType = "NotActType",
	Flash = "Flash",
	Friend = "Friend",
	HuntHoney = "HuntHoney",
}


export enum TActState {
	UnkonwnActState = "UnkonwnActState",
	ComingSoon = "ComingSoon",
	OnGoing = "OnGoing",
	Ended = "Ended",
}


export enum CouponType {
	CopyCoupon = "CopyCoupon",
	ReceiveCoupon = "ReceiveCoupon",
}



export interface CreateGroupReq {
	group: TGroup;
}

export interface CreateGroupResp {
	result?: PageResult;
	groupId?: string;
}

export interface ListGroupReq {
	catalog: string;
	search?: SearchReq;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
	groupType?: GroupType;
}

export interface SearchReq {
	keyword?: string;
	groupId?: string;
	name?: string;
	owner?: string;
}

export interface ListGroupResp {
	groups?: TGroup[];
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	total?: number;
}

export interface TGroup {
	id?: string;
	name?: string;
	catalog?: string;
	/**
	 * @pattern ^\d+$
	 */
	createDate?: string;
	/**
	 * @pattern ^\d+$
	 */
	updateDate?: string;
	updateBy?: string;
	owner?: string;
	/**
	 * @pattern ^\d+$
	 */
	start?: string;
	/**
	 * @pattern ^\d+$
	 */
	end?: string;
	groupType?: GroupType;
	includeArea?: string[];
}

export interface GetPlaygroundReq {
	id: string;
	version?: string;
}

export interface GetPlaygroundResp {
	playground?: TPlayground;
	mids?: string[];
	mobileMids?: string[];
}

export interface CreatePlaygroundReq {
	playground: TPlayground;
}

export interface CreatePlaygroundResp {
	result?: PageResult;
	id?: string;
}

export interface SavePlaygroundReq {
	playground: TPlayground;
	modules?: TModule[];
}

export interface SavePlaygroundResp {
	result?: PageResult;
}

export interface UpdatePlaygroundReq {
	playground: TPlayground;
}

export interface UpdatePlaygroundResp {
	result?: PageResult;
}

export interface PublishPlaygroundReq {
	id: string;
	version: string;
	updateBy: string;
	/**
	 * @pattern ^\d+$
	 */
	publishDate?: string;
}

export interface PublishPlaygroundResp {
	result?: PageResult;
}

export interface DeletePlaygroundReq {
	id: string;
	updateBy: string;
}

export interface DeletePlaygroundResp {
	result?: PageResult;
}

export interface GetPlaygroundListReq {
	catalog: string;
	type?: TPlaygroundType;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
	search?: SearchReq;
	site?: string;
}

export interface GetPlaygroundListByGroupReq {
	catalog?: string;
	groupId?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
}

export interface GetPlaygroundListResp {
	playgrounds?: TPlayground[];
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	total?: number;
}

export interface SetVersionReq {
	pageId: string;
	versions?: string[];
}

export interface GetModulesReq {
	moduleIds?: string[];
	site?: string;
}

export interface GetModulesResp {
	mods?: TModule[];
}

export interface TPlayground {
	id?: string;
	groupId: string;
	groupName?: string;
	catalog: string;
	slug: string;
	platform?: TPlatform;
	name?: string;
	typ?: TPlaygroundType;
	/**
	 * @pattern ^\d+$
	 */
	createDate?: string;
	/**
	 * @pattern ^\d+$
	 */
	updateDate?: string;
	updateBy: string;
	isDisable?: boolean;
	redirectSlug?: string;
	/**
	 * @pattern ^\d+$
	 */
	start?: string;
	/**
	 * @pattern ^\d+$
	 */
	end?: string;
	/**
	 * @pattern ^\d+$
	 */
	publishDate?: string;
	isDel?: boolean;
	publishVersion?: string;
	versions?: string[];
	seoKeyword?: string;
	seoDesc?: string;
	ui?: Ui;
	access?: Access;
	site?: string;
	isNewPage?: boolean;
}

export interface Access {
	include?: string[];
	exclude?: string[];
	includeLang?: string[];
}

export interface CopyPlaygroundReq {
	playgroundId: string;
	src: string;
	dests: string[];
	updateBy: string;
	owner: string;
	groupName?: string;
}

export interface CopyPlaygroundResp {
	result?: PageResult;
}

export interface TModule {
	id?: string;
	type?: TModuleType;
	isDisable?: boolean;
	header?: TModuleHeader;
	module?: {"@type": string; [key: string]: any};
	layout?: Layout;
	platform?: TPlatform;
	ui?: Ui;
	userInfo?: UserInfo;
	time?: TTimeModule;
	platforms?: TPlatform[];
}

export interface TModuleHeader {
	title?: TTextModule;
	subTitle?: TTextModule;
	link?: string;
	img?: string;
	isDisable?: boolean;
	position?: string;
	relatedId?: string;
}

export interface Layout {
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	rowNum?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	columnNum?: number;
	stickToTop?: boolean;
	interaction?: PageModuleInteraction;
}

export interface Ui {
	bgColor?: string;
	colorTable?: {[key: string]: string};
	shape?: Shape;
}

export interface UserInfo {
	ug?: number[];
}

export interface International {
	text?: string;
	img?: string;
	imgTwo?: string;
	link?: string;
}

export interface InternationalGroup {
	igroup?: {[key: string]: International};
}

export interface TCategoryModule {
	elements?: TCategoryElement[];
}

export interface TCategoryExtensionModule {
	elements?: TCategoryExtensionElement[];
}

export interface Extend {
	imgOnly?: boolean;
	hideTitle?: boolean;
	hideCollection?: boolean;
	hideOriginPrice?: boolean;
	hideDiscountPrice?: boolean;
	longImg?: boolean;
	mailPrice?: boolean;
}

export interface TProductModule {
	poolId?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	cid?: number;
	activeId?: string;
	actType?: ActType;
	name?: string;
	canLoadMore?: boolean;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	maxLoad?: number;
	tabExpand?: boolean;
	productElements?: TProductElement[];
	ui?: Ui;
	extension?: Extend;
	ig?: InternationalGroup;
	link?: string;
}

export interface TMultiProductModule {
	proModules?: TProductModule[];
}

export interface TMultiFlashModule {
	flashModules?: TFlashModule[];
	multiTab?: boolean;
	isActView?: boolean;
}

export interface TFlashModule {
	pro?: TProductModule;
	isActView?: boolean;
	flashName?: string;
	/**
	 * @pattern ^\d+$
	 */
	endSpan?: string;
	/**
	 * @pattern ^\d+$
	 */
	startSpan?: string;
	state?: TActState;
}

export interface TDiscountModule {
	proModules?: TProductModule[];
	multiTab?: boolean;
}

export interface TActModule {
	cd?: TCountdownModule;
	proModule?: TProductModule;
}

export interface TBannerModule {
	elements?: TBannerElement[];
}

export interface THomeBannerModule {
	items?: TBannerItem[];
}

export interface TTimeLineBannerModule {
	items?: TBannerItem[];
}

export interface TCountdownBannerModule {
	timer?: TCountdownModule;
	state?: TActState;
	banner?: TBannerBasic;
}

export interface TMagicBannerModule {
	banner?: TBannerItem;
	items?: TMagicItem[];
}

export interface TMagicBannerTwoModule {
	banners?: TBannerItem[];
	items?: TMagicItem[];
}

export interface TSideBannerModule {
	left?: TBannerItem;
	right?: TBannerItem;
}

export interface TPageTitleLineModule {
	text?: TTextModule;
	share?: TShareModule;
}

export interface TMultiHeroDealModule {
	heroDealModules?: THeroDealModule[];
}

export interface THeroDealModule {
	proModule?: TProductModule;
	cd?: TCountdownModule;
	ShowCountDown?: boolean;
	detail?: string;
	link?: string;
}

export interface TNavIconGroupsModule {
	iconGroups?: TIconGroupModule[];
}

export interface TMultiCollectionModule {
	collectionModules?: TCollectionModule[];
}

export interface TCollectionModule {
	banner?: TBannerBasic;
	proModule?: TProductModule;
	time?: TTimeModule;
}

export interface TMultiRecPurTabModule {
	recPurTabModules?: TRecPurTabModule[];
}

export interface TRecPurTabModule {
	banner?: TBannerBasic;
	userInfo?: UserInfo;
	proModule?: TProductModule;
	time?: TTimeModule;
}

export interface TMultiCollectionTwoModule {
	colTwoModules?: TCollectionTwoModule[];
}

export interface TCollectionTwoModule {
	banner?: TBannerBasic[];
}

export interface TNoLoginBannerModule {
	items?: TBannerItem[];
}

export interface TFlashAreaModule {

}

export interface TMillionModule {

}

export interface TActEventModule {
	activeId?: string;
	banner?: TBannerBasic;
	actType?: ActType;
}

export interface TCouponModule {
	couponCode?: string;
	info?: TBannerBasic;
	ui?: Ui;
}

export interface TCouponGroupModule {
	coupons?: TCouponModule[];
	couponType?: CouponType;
}

export interface TTextModule {
	content?: string;
	color?: string;
	fontSize?: string;
	link?: string;
	target?: boolean;
	ig?: InternationalGroup;
}

export interface TIconModule {
	icon?: TBannerBasic;
	ui?: Ui;
	time?: TTimeModule;
}

export interface TShareModule {
	title?: string;
	content?: string;
	img?: string;
	link?: string;
	ig?: InternationalGroup;
}

export interface TTimeModule {
	/**
	 * @pattern ^\d+$
	 */
	start?: string;
	/**
	 * @pattern ^\d+$
	 */
	end?: string;
	/**
	 * @pattern ^\d+$
	 */
	left?: string;
}

export interface TCountdownModule {
	time?: TTimeModule;
	text?: TTextModule;
}

export interface THotKeywordsModule {
	keywords?: TTextModule[];
}

export interface TTextGroupModule {
	texts?: TTextModule[];
}

export interface TIconGroupModule {
	icons?: TIconModule[];
}

export interface TVoucherModule {
	/**
	 * @pattern ^\d+$
	 */
	voucherId?: string;
	info?: TBannerBasic;
	ui?: Ui;
}

export interface TVoucherGroupModule {
	vouchers?: TVoucherModule[];
}

export interface TBannerElement {
	items?: TBannerItem[];
}

export interface TBannerItem {
	img?: string;
	link?: string;
	time?: TTimeModule;
	isDefault?: boolean;
	extension?: TModuleExtension;
	ig?: InternationalGroup;
	width?: string;
	height?: string;
}

export interface TBannerBasic {
	title?: string;
	img?: string;
	link?: string;
	imgTwo?: string;
	ig?: InternationalGroup;
	width?: string;
	height?: string;
}

export interface TMagicItem {
	link?: string;
	width?: string;
	height?: string;
	left?: string;
	top?: string;
}

export interface TProductElement {
	/**
	 * @pattern ^\d+$
	 */
	gpid?: string;
	name?: string;
	img?: string;
	price?: string;
	originPrice?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	stock?: number;
	/**
	 * @pattern ^\d+$
	 */
	start?: string;
	/**
	 * @pattern ^\d+$
	 */
	end?: string;
	isSoldout?: boolean;
	url?: string;
	/**
	 * @pattern ^\d+$
	 */
	leftTime?: string;
	/**
	 * @pattern ^\d+$
	 */
	priceInt?: string;
	/**
	 * @pattern ^\d+$
	 */
	originPriceInt?: string;
	/**
	 * @pattern ^\d+$
	 */
	baseGpid?: string;
	extra?: PoolExtraInfo;
	fileName?: string;
}

export interface TCategoryElement {
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	id?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	parentId?: number;
	name?: string;
	img?: string;
	imgTwo?: string;
	cats?: TCategoryElement[];
	hotCats?: TCategoryElement[];
}

export interface TCategoryExtensionElement {
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	cid?: number;
	bannerModule?: TBannerModule;
	productModule?: TProductModule;
}

export interface TModuleExtension {
	seo?: string;
	membersShipIds?: number[];
}

export interface FixProductModuleFetchReq {
	mid: string;
}

export interface GetFlashInfoReq {
	actId: string;
}

export interface GetFlashInfoResp {
	actId?: string;
	settingName?: string;
	/**
	 * @pattern ^\d+$
	 */
	startTime?: string;
	/**
	 * @pattern ^\d+$
	 */
	endTime?: string;
	/**
	 * @pattern ^\d+$
	 */
	productCount?: string;
}

export interface GetPageSaveLogReq {
	pageId?: string;
	version?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
	needReq?: boolean;
}

export interface GetPageSaveLogResp {
	saveLogs?: SaveLog[];
	/**
	 * @pattern ^\d+$
	 */
	total?: string;
}

export interface SaveLog {
	pageId?: string;
	version?: string;
	saveReq?: string;
	/**
	 * @pattern ^\d+$
	 */
	createDate?: string;
	createBy?: string;
}

export interface GetActInfoReq {
	actId?: string;
	actType?: ActType;
}

export interface GetActInfoResp {
	actId?: string;
	catalog?: string;
	actName?: string;
	/**
	 * @pattern ^\d+$
	 */
	startTime?: string;
	/**
	 * @pattern ^\d+$
	 */
	endTime?: string;
}

export interface MailTpl {
	groupId?: string;
	pageId?: string;
	code?: string;
	/**
	 * @pattern ^\d+$
	 */
	sendDate?: string;
}

export interface CreateMailTplReq {
	mailTpl?: MailTpl;
}

export interface CreateMailTplResp {
	result?: PageResult;
}

export interface UpdateMailTplReq {
	mailTpl?: MailTpl;
}

export interface UpdateMailTplResp {
	result?: PageResult;
}

export interface GetMailTplReq {
	pageId?: string;
}

export interface GetMailTplResp {
	mtPlayground?: TMailTplPlayground;
}

export interface GetMailTplsByGroupReq {
	groupId?: string;
	pageId?: string;
	area?: string;
	lang?: string;
	name?: string;
	code?: string;
	updateBy?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
}

export interface TMailTplPlayground {
	playground?: TPlayground;
	mailTpl?: MailTpl;
}

export interface GetMailTplsByGroupResp {
	mtPlaygrounds?: TMailTplPlayground[];
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	total?: number;
}

export interface GetMailTplListReq {
	pageId?: string;
	name?: string;
	updateBy?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	offset?: number;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
	site?: string;
}

export interface GetMailTplListResp {
	mtPlaygrounds?: TMailTplPlayground[];
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	total?: number;
}

export interface UpdateGroupReq {
	group?: TGroup;
}

export interface UpdateGroupResp {
	result?: PageResult;
}



export function CreateGroup(payload: Partial<CreateGroupReq>, options?: any) {
	return webapi<CreateGroupResp>("page.Admin/CreateGroup", payload, options);
}

export function ListGroup(payload: Partial<ListGroupReq>, options?: any) {
	return webapi<ListGroupResp>("page.Admin/ListGroup", payload, options);
}

export function SavePlayground(payload: Partial<SavePlaygroundReq>, options?: any) {
	return webapi<SavePlaygroundResp>("page.Admin/SavePlayground", payload, options);
}

export function UpdatePlayground(payload: Partial<UpdatePlaygroundReq>, options?: any) {
	return webapi<UpdatePlaygroundResp>("page.Admin/UpdatePlayground", payload, options);
}

export function PublishPlayground(payload: Partial<PublishPlaygroundReq>, options?: any) {
	return webapi<PublishPlaygroundResp>("page.Admin/PublishPlayground", payload, options);
}

export function CreatePlayground(payload: Partial<CreatePlaygroundReq>, options?: any) {
	return webapi<CreatePlaygroundResp>("page.Admin/CreatePlayground", payload, options);
}

export function GetPlayground(payload: Partial<GetPlaygroundReq>, options?: any) {
	return webapi<GetPlaygroundResp>("page.Admin/GetPlayground", payload, options);
}

export function DeletePlayground(payload: Partial<DeletePlaygroundReq>, options?: any) {
	return webapi<DeletePlaygroundResp>("page.Admin/DeletePlayground", payload, options);
}

export function GetPlaygroundList(payload: Partial<GetPlaygroundListReq>, options?: any) {
	return webapi<GetPlaygroundListResp>("page.Admin/GetPlaygroundList", payload, options);
}

export function GetPlaygroundListByGroup(payload: Partial<GetPlaygroundListByGroupReq>, options?: any) {
	return webapi<GetPlaygroundListResp>("page.Admin/GetPlaygroundListByGroup", payload, options);
}

export function CopyPlayground(payload: Partial<CopyPlaygroundReq>, options?: any) {
	return webapi<CopyPlaygroundResp>("page.Admin/CopyPlayground", payload, options);
}

export function SetVersion(payload: Partial<SetVersionReq>, options?: any) {
	return webapi<PageResult>("page.Admin/SetVersion", payload, options);
}

export function GetPageSaveLog(payload: Partial<GetPageSaveLogReq>, options?: any) {
	return webapi<GetPageSaveLogResp>("page.Admin/GetPageSaveLog", payload, options);
}

export function GetModules(payload: Partial<GetModulesReq>, options?: any) {
	return webapi<GetModulesResp>("page.Admin/GetModules", payload, options);
}

export function FixProductModuleFetch(payload: Partial<FixProductModuleFetchReq>, options?: any) {
	return webapi<PageResult>("page.Admin/FixProductModuleFetch", payload, options);
}

export function GetFlashInfo(payload: Partial<GetFlashInfoReq>, options?: any) {
	return webapi<GetFlashInfoResp>("page.Admin/GetFlashInfo", payload, options);
}

export function GetActInfo(payload: Partial<GetActInfoReq>, options?: any) {
	return webapi<GetActInfoResp>("page.Admin/GetActInfo", payload, options);
}

export function CreateMailTpl(payload: Partial<CreateMailTplReq>, options?: any) {
	return webapi<CreateMailTplResp>("page.Admin/CreateMailTpl", payload, options);
}

export function UpdateMailTpl(payload: Partial<UpdateMailTplReq>, options?: any) {
	return webapi<UpdateMailTplResp>("page.Admin/UpdateMailTpl", payload, options);
}

export function GetMailTplsByGroup(payload: Partial<GetMailTplsByGroupReq>, options?: any) {
	return webapi<GetMailTplsByGroupResp>("page.Admin/GetMailTplsByGroup", payload, options);
}

export function GetMailTpl(payload: Partial<GetMailTplReq>, options?: any) {
	return webapi<GetMailTplResp>("page.Admin/GetMailTpl", payload, options);
}

export function GetMailTplList(payload: Partial<GetMailTplListReq>, options?: any) {
	return webapi<GetMailTplListResp>("page.Admin/GetMailTplList", payload, options);
}

export function UpdateGroup(payload: Partial<UpdateGroupReq>, options?: any) {
	return webapi<UpdateGroupResp>("page.Admin/UpdateGroup", payload, options);
}


export default {
	CreateGroup,
	ListGroup,
	SavePlayground,
	UpdatePlayground,
	PublishPlayground,
	CreatePlayground,
	GetPlayground,
	DeletePlayground,
	GetPlaygroundList,
	GetPlaygroundListByGroup,
	CopyPlayground,
	SetVersion,
	GetPageSaveLog,
	GetModules,
	FixProductModuleFetch,
	GetFlashInfo,
	GetActInfo,
	CreateMailTpl,
	UpdateMailTpl,
	GetMailTplsByGroup,
	GetMailTpl,
	GetMailTplList,
	UpdateGroup,
};